<template>
  <div class="container mt-5">
    <div class="text-section">
      <h1 class="konfirmasi-title">Cek Data Kendaraan</h1>
      <p class="description">Pengecekan data kendaraan yang tercapture tilang secara elektronik.</p>
    </div>

    <div class="row form-container">
      <div class="col-md-6 form-section">
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label for="noPolisi">
              <i class="fas fa-car"></i>
              No. TNKB <span class="required">*</span>
            </label>
            <input type="text" class="form-control" id="noPolisi" v-model="noPolisi" placeholder="Contoh: BG8123UK"
              :class="{ 'is-invalid': errors.noPolisi }" @input="clearError('noPolisi')" required autocomplete="off">
            <div v-if="errors.noPolisi" class="invalid-feedback">
              {{ errors.noPolisi }}
            </div>
          </div>

          <div class="form-group">
            <label for="noRangka">
              <i class="fas fa-barcode"></i>
              No. Rangka <span class="required">*</span>
            </label>
            <input type="text" class="form-control" id="noRangka" v-model="noRangka"
              placeholder="Masukkan nomor rangka kendaraan" :class="{ 'is-invalid': errors.noRangka }"
              @input="clearError('noRangka')" required autocomplete="off">
            <div v-if="errors.noRangka" class="invalid-feedback">
              {{ errors.noRangka }}
            </div>
          </div>

          <div class="form-group">
            <label for="noMesin">
              <i class="fas fa-cog"></i>
              No. Mesin <span class="required">*</span>
            </label>
            <input type="text" class="form-control" id="noMesin" v-model="noMesin"
              placeholder="Masukkan nomor mesin kendaraan" :class="{ 'is-invalid': errors.noMesin }"
              @input="clearError('noMesin')" required autocomplete="off">
            <div v-if="errors.noMesin" class="invalid-feedback">
              {{ errors.noMesin }}
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-secondary btn-batal" @click="resetForm" :disabled="loading">
              <i class="fas fa-times"></i>
              Batal
            </button>
            <button type="submit" class="btn btn-primary btn-lanjut" :disabled="loading">
              <i v-if="loading" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-search"></i>
              {{ loading ? 'Mencari...' : 'Proses Cek Data' }}
            </button>
          </div>
        </form>
      </div>

      <div class="col-md-6 image-section">
        <div class="image-wrapper">
          <img src="@/assets/right-login.png" class="img-fluid vehicle-img" alt="Illustration of a vehicle" />
          <div style="color: #053db7;">
            <h4>Pantau Pelanggaran Truk ODOL<br>Secara Online</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      noPolisi: '',
      noRangka: '',
      noMesin: '',
      loading: false,
      errors: {}
    };
  },
  methods: {
    validateForm() {
      this.errors = {};
      let isValid = true;

      // Validasi No. Polisi
      if (!this.noPolisi.trim()) {
        this.errors.noPolisi = 'Nomor TNKB wajib diisi';
        isValid = false;
      } else if (this.noPolisi.trim().length < 5) {
        this.errors.noPolisi = 'Nomor TNKB tidak valid';
        isValid = false;
      }

      // Validasi No. Rangka
      if (!this.noRangka.trim()) {
        this.errors.noRangka = 'Nomor rangka wajib diisi';
        isValid = false;
      } else if (this.noRangka.trim().length < 10) {
        this.errors.noRangka = 'Nomor rangka minimal 10 karakter';
        isValid = false;
      }

      // Validasi No. Mesin
      if (!this.noMesin.trim()) {
        this.errors.noMesin = 'Nomor mesin wajib diisi';
        isValid = false;
      } else if (this.noMesin.trim().length < 5) {
        this.errors.noMesin = 'Nomor mesin minimal 5 karakter';
        isValid = false;
      }

      return isValid;
    },

    clearError(field) {
      if (this.errors[field]) {
        delete this.errors[field];
      }
    },

    async submitForm() {
      if (!this.validateForm()) {
        Swal.fire({
          icon: 'warning',
          title: 'Data Tidak Lengkap',
          text: 'Mohon periksa kembali data yang Anda masukkan',
          confirmButtonColor: '#007bff'
        });
        return;
      }

      this.loading = true;
      const url = `${process.env.VUE_APP_API_URL}/etle/admin-etle/cek-data-kendaraan.php`;

      try {
        const response = await axios.get(url, {
          params: {
            noPolisi: this.noPolisi.trim(),
            noRangka: this.noRangka.trim(),
            noMesin: this.noMesin.trim()
          },
          timeout: 30000
        });

        if (response.data && response.data.data && response.data.data.length > 0) {
          const dataToSave = {
            data: response.data.data,
            vehicleInfo: {
              noPolisi: this.noPolisi.trim(),
              noRangka: this.noRangka.trim(),
              noMesin: this.noMesin.trim()
            },
            timestamp: new Date().getTime()
          };
          sessionStorage.setItem('pelanggaranData', JSON.stringify(dataToSave));

          await Swal.fire({
            icon: 'success',
            title: 'Data Ditemukan!',
            text: `Ditemukan ${response.data.data.length} data pelanggaran`,
            confirmButtonColor: '#28a745',
            timer: 2000,
            timerProgressBar: true
          });

          this.$router.push({
            name: 'DataPelanggaran',
            params: {
              pelanggaranData: response.data.data,
              vehicleInfo: {
                noPolisi: this.noPolisi.trim(),
                noRangka: this.noRangka.trim(),
                noMesin: this.noMesin.trim()
              }
            }
          });
        } else {
          Swal.fire({
            icon: 'info',
            title: 'Data Tidak Ditemukan',
            text: 'Tidak ada data pelanggaran untuk kendaraan ini',
            confirmButtonColor: '#007bff'
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        let errorMessage = 'Terjadi kesalahan saat mengambil data';
        if (error.code === 'ECONNABORTED') {
          errorMessage = 'Koneksi timeout. Silakan coba lagi';
        } else if (error.response?.status === 404) {
          errorMessage = 'Service tidak tersedia saat ini';
        } else if (error.response?.status >= 500) {
          errorMessage = 'Server sedang bermasalah. Silakan coba lagi nanti';
        }

        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: errorMessage,
          confirmButtonColor: '#dc3545'
        });
      } finally {
        this.loading = false;
      }
    },

    async resetForm() {
      if (this.noPolisi || this.noRangka || this.noMesin) {
        const result = await Swal.fire({
          title: 'Hapus Semua Data?',
          text: 'Apakah Anda yakin ingin menghapus semua data yang sudah diisi?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#dc3545',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Ya, Hapus',
          cancelButtonText: 'Batal'
        });

        if (result.isConfirmed) {
          this.noPolisi = '';
          this.noRangka = '';
          this.noMesin = '';
          this.errors = {};

          Swal.fire({
            icon: 'success',
            title: 'Data Dihapus',
            text: 'Semua data berhasil dihapus',
            timer: 1500,
            showConfirmButton: false
          });
        }
      }
    }
  }
};
</script>

<style scoped>
/* Import Font Awesome untuk icons */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');

.container {
  max-width: 1200px;
}

.text-section {
  text-align: center;
  margin-bottom: 40px;
  padding: 20px 0;
}

.konfirmasi-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  background: linear-gradient(45deg, #007bff, #0056b3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.description {
  color: #6c757d;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.form-container {
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 40px;
  margin-bottom: 150px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.form-section {
  padding-right: 30px;
}

.form-group {
  margin-bottom: 25px;
}

.form-group label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: block;
  font-size: 0.95rem;
}

.form-group label i {
  margin-right: 8px;
  color: #007bff;
  width: 16px;
}

.required {
  color: #dc3545;
  font-weight: bold;
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background-color: #fff;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
  background-color: #fff;
}

.form-control.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 5px;
  font-size: 0.875rem;
  color: #dc3545;
}

.form-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

.btn {
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 130px;
  justify-content: center;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-batal {
  background-color: #6c757d;
  color: white;
}

.btn-batal:hover:not(:disabled) {
  background-color: #545b62;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.btn-lanjut {
  background: linear-gradient(45deg, #007bff, #0056b3);
  color: white;
}

.btn-lanjut:hover:not(:disabled) {
  background: linear-gradient(45deg, #0056b3, #004085);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.image-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.image-wrapper {
  text-align: center;
  width: 100%;
}

.vehicle-img {
  max-width: 300px;
  height: auto;
  margin-bottom: 20px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.info-card {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
  border-left: 4px solid #007bff;
}

.info-card h5 {
  color: #1976d2;
  font-weight: 600;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-card li {
  padding: 5px 0;
  color: #424242;
  font-size: 0.9rem;
  position: relative;
  padding-left: 20px;
}

.info-card li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #4caf50;
  font-weight: bold;
}

.fa-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .konfirmasi-title {
    font-size: 2rem;
  }

  .form-container {
    padding: 20px;
  }

  .form-section {
    padding-right: 0;
    margin-bottom: 30px;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }

  .vehicle-img {
    max-width: 250px;
  }

  .info-card {
    margin-top: 15px;
    padding: 15px;
  }
}

@media (max-width: 576px) {
  .container {
    padding: 15px;
  }

  .text-section {
    margin-bottom: 20px;
  }

  .konfirmasi-title {
    font-size: 1.8rem;
  }
}
</style>